import axios from 'axios'
import {API_URL} from '../constants';

const MATERIAL_STOCK_API_URL = `${API_URL}/materialStocks`;

class MaterialStockService {
    retrieveMaterialItems() {
        let s = localStorage.getItem("material_items");
        if (s !== undefined && s !== null){
            return Promise.resolve(JSON.parse(s));
        }

        const token = sessionStorage.getItem('token');
        return axios.get(`${MATERIAL_STOCK_API_URL}/materialItems`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("material_items", JSON.stringify(response.data));
            return response.data;
        }).catch(error => {
            localStorage.setItem("material_items", '[]');
            return error;
        });
    }

    fetchMaterials() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${MATERIAL_STOCK_API_URL}/`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    fetchMaterialStocks(page, pageSize, fromDate, toDate, searchCode, searchSeller, searchStatus, groupOnly) {
        // console.log(searchStatus);
        let statusList = [];

        if (searchStatus !== null && searchStatus !== undefined){
            for(let i=0; i<searchStatus.length; i++){
                statusList.push(searchStatus[i].id);
            }
        }

        const token = sessionStorage.getItem('token');
        return axios.post(`${MATERIAL_STOCK_API_URL}/by`,  {page: page, pageSize: pageSize, fromDate: fromDate, toDate: toDate, code: searchCode, seller: searchSeller, statusList: statusList, groupOnly: groupOnly},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }    

    updateQuantity(item) {
        let info = {
            id: item.id,
            total: item.total,
            quantity: item.quantity,
            batchNoGroup: item.batchNoGroup,
            seller: item.seller,
            count: item.count,
            stockDate: item.stockDate,
            code: item.selectedCode,
            name: item.selectedCode
        }

        const token = sessionStorage.getItem('token');
        return axios.put(`${MATERIAL_STOCK_API_URL}/${item.id}`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    createMaterialStock(item) {
        let info = {
            id: item.id,
            soCan: item.soCan,
            dungTich: item.dungTich,
            batchNoGroup: item.batchNoGroup,
            seller: item.seller,
            count: item.count,
            stockDate: item.stockDate,
            code: item.selectedCode,
            name: item.selectedCode,
            canCode: item.canCode
        }
        const token = sessionStorage.getItem('token');
        return axios.post(`${MATERIAL_STOCK_API_URL}/`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    updateMaterialStock(item) {
        let info = {
            id: item.id,
            soCan: item.soCan,
            dungTich: item.dungTich,
            batchNoGroup: item.batchNoGroup,
            seller: item.seller,
            count: item.count,
            stockDate: item.stockDate,
            code: item.selectedCode,
            name: item.selectedCode,
            batchNoGroupInit: item.batchNoGroupInit
        }
        const token = sessionStorage.getItem('token');
        return axios.put(`${MATERIAL_STOCK_API_URL}/`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    deliveryMaterialStock(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${MATERIAL_STOCK_API_URL}/delivery`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }    

    deleteMaterialStock(id) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${MATERIAL_STOCK_API_URL}/${id}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    deleteMaterialStockByBatchNoGroup(batchNoGroup) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${MATERIAL_STOCK_API_URL}/batchNoGroups/${batchNoGroup}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }    

    fetchMaterialStockByBatchNo(batchNo) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${MATERIAL_STOCK_API_URL}/${batchNo}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return {};
        });
    }

    fetchMaterialStockByBatchNoGroup(batchNoGroup) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${MATERIAL_STOCK_API_URL}/batchNoGroups/${batchNoGroup}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return {};
        });
    }    

    exportMaterialStocks(batchNoGroups){
        const token = sessionStorage.getItem('token');       
        return axios.post(`${MATERIAL_STOCK_API_URL}/export`, { batchNoGroups: batchNoGroups },
            { 
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob' 
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    fetchInventory(fromDate, toDate) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${MATERIAL_STOCK_API_URL}/inventory`,  { fromDate: fromDate, toDate: toDate },
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    fetchMaterialMappingBy(materialCode) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${MATERIAL_STOCK_API_URL}/materialMappings/${materialCode}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return {};
        });
    }

    updateMaterialMapping(mappingMaterial){
        const token = sessionStorage.getItem('token');       
        return axios.post(`${MATERIAL_STOCK_API_URL}/materialMappings`, mappingMaterial,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }       
}

export default new MaterialStockService();
